import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'base',
    component: () => import(/* webpackChunkName: "base" */ '../views/base.vue')
  },
  {
    path: '/detail',
    name: 'detail',
    component: () => import(/* webpackChunkName: "detail" */ '../views/detail.vue')
  },
//   {
//     path: '/success',
//     name: 'success',
//     component: () => import(/* webpackChunkName: "detail" */ '../views/success1.vue')
//   }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
